<template>
<div class="preabs">

    <topheader back="back">
		 <template v-slot:info>
            <span>{{$t('plans.support.contact')}}</span>
        </template>
    </topheader>

	<maincontent>
		<template v-slot:content>
			<div class="supportwrapper">
				<div class="subcaption">
					<span>
						{{$t('snippity.supportIntroMessage')}}
					</span>
				</div>
				<a href="mailto:support@snippity.app">
					<button class="button orange">
						{{$t('plans.support.contact')}}
					</button>
				</a>
			</div>
		</template>
	</maincontent>

</div>
</template>

<style lang="sass" scoped>

	.supportwrapper
		height: 70vh
		display: flex
		align-items: center
		justify-content: center
		text-align: center
		flex-flow: column

		.subcaption
			text-align: center
			margin-bottom: 4 * $r

</style>

<script>
export default {
    name: 'support_page',
    components: {

    },

    computed: {

    },

    methods: {

    },

    mounted() {

    }
}
</script>
